import { asyncRoutes, constantRoutes } from '@/router';

async function hasAbilities(route, abilities) {
  if (route.name) {
    const result = abilities.filter((ability) => {
      if (ability.meta.action !== undefined) {
        if (route.name === ability.name && ability.meta.action.r) {
          route.meta.action = ability.meta.action;
          return true;
        }
      }
    });
    if (result.length) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
}

const filterAbilityRoutes = async (routes, abilities) => {
  const abilityRoute = [];
  let prefix = '[store/modules/permission.js][filterAbilityRoutes]';
  // try {
  //   console.log(`${prefix} abilities: ${JSON.stringify(abilities)}`)
  // } catch (error) {
  //   console.log(`${prefix} error: ${error}`)
  // }
  routes.forEach(async (route) => {
    // console.log(`${prefix} route: ${JSON.stringify(route)}`)
    const rc = [];
    if (route.children) {
      await route.children.forEach(async (routeC) => {
        const hasAb = await hasAbilities(routeC, abilities);
        if (hasAb) {
          rc.push(routeC);
        }
      });
      route.children = rc;
    }

    if (rc.length) {
      abilityRoute.push(route);
    }
  });
  return abilityRoute;
};

async function filterAdminRoutes(routes, abilities) {
  routes.forEach((route) => {
    if (route.children) {
      route.children.forEach((routeChild) => {
        if (routeChild.meta.action !== undefined) {
          for (const item in routeChild.meta.action) {
            routeChild.meta.action[item] = true;
          }
        }
      });
    }
  });
  return routes;
}

const state = {
  routes: [],
  addRoutes: [],
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
};

const actions = {
  async routesAbility({ commit }, { roles, abilities }) {
    if (typeof abilities === 'string') {
      abilities = JSON.parse(abilities);
    }
    let accessedRoutes;
    const [role] = roles;
    if (process.env.NODE_ENV !== 'development') {
      asyncRoutes.forEach((route) => {
        if (route.name === 'Users') {
          route.children.splice(1, 1);
        }
      });
    }
    if (role.includes('admin')) {
      accessedRoutes = await filterAdminRoutes(asyncRoutes, abilities);
    } else {
      const routes = await filterAbilityRoutes(asyncRoutes, abilities);
      accessedRoutes = routes;
    }
    commit('SET_ROUTES', accessedRoutes);
    return accessedRoutes;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
